import { defineStore } from 'pinia'
import { applicationCode, getHeader } from '@/assets/js/config.js';
import axios from 'axios';

export const useHttpStore = defineStore('http', {
  state: () => ({
  }),
  getters: {
  },
  actions: {
    get(url, data = {}, headers = {}) {
			let head = getHeader();
      return new Promise((resolve, reject) => {
        axios.get(url, {
          params: data,
          headers: {
            ...head,
            ...headers
          }
        }).then(response => {
          if (response.status >= 200 && response.status < 300) {
            resolve(response);
          }
        }).catch(error => {
					reject(error);
        });
      });
    },
  
    post(url, data, headers = {}) {
			let head = getHeader();
      return new Promise((resolve, reject) => {
        axios.post(url, data, {
          headers: {
            ...head,
            ...headers
          }
        }).then(response => {
          resolve(response);
        }).catch(error => {
          reject(error);
        });
      });
    },
  
    patch(url, data, headers = {}) {
			let head = getHeader();
      return new Promise((resolve, reject) => {
        axios.patch(url, data, {
          headers: {
            ...head,
            ...headers
          }
        }).then(response => {
          resolve(response);
        }).catch(error => {
          reject(error);
        });
      });
    },
  
    put(url, data, headers = {}) {
			let head = getHeader();
      return new Promise((resolve, reject) => {
        axios.put(url, data, {
          headers: {
            ...head,
            ...headers
          }
        }).then(response => {
          resolve(response);
        }).catch(error => {
          reject(error);
        });
      });
    },

    delete(url) {
      return new Promise((resolve, reject) => {
        axios.delete(url, {
          headers: getHeader()
        }).then(response => {
          resolve(response);
        }).catch(error => {
          reject(error);
        });
      });
    },
  
    convertPaginationKeys(respData) {
			const meta = !_gHlp.isEmpty(respData.meta) ? respData.meta : respData;
			const links = !_gHlp.isEmpty(respData.links) ? respData.links : respData;
			let first_page_url = (!_gHlp.isEmpty(links.first)) ? links.first : links.first_page_url;
			let last_page_url = (!_gHlp.isEmpty(links.last)) ? links.last : links.last_page_url;
			let next_page_url = (!_gHlp.isEmpty(links.next)) ? links.next : links.next_page_url;
			let prev_page_url = (!_gHlp.isEmpty(links.prev)) ? links.prev : links.prev_page_url;

      respData.pagination = {
        currentPage: meta.current_page,
        lastPage: meta.last_page,
        perPage: Number(meta.per_page),
        firstPageUrl: first_page_url || null,
        lastPageUrl: last_page_url || null,
        nextPageUrl: next_page_url || null,
        prevPageUrl: prev_page_url || null,
        from: meta.from,
        to: meta.to,
        total: meta.total
      };
      const deleteFields = [
        'current_page',
        'last_page',
        'per_page',
        'first_page_url',
        'last_page_url',
        'next_page_url',
        'prev_page_url',
        'from',
        'to',
        'total'
      ];
  
      for (let i = 0; i < deleteFields.length; i++) {
        delete respData[deleteFields[i]];
      }
    },
  }
})